import { WISHLIST_LOCAL_STORAGE_KEY } from '@/services/wishlist';

App.namespace('es6.shared.wish_list', () => {
  const HEARTS_SELECTOR = '.js-wishlist-toggle';

  let wishListRooms = [];
  let userData = null;

  const TRACKING_ACTIONS = {
    add: 'add',
    autoAdd: 'auto-add',
    addGuest: 'add-guest',
    remove: 'remove',
  };

  const track = (action, roomId, tracking) => {
    App.track.custom(window.__DATA_TRACKING_WISHLIST_ACTIONS, {
      action,
      roomId,
      tagSlug: window.__DATA_TRACKING_VAR__TAG_SLUG,
    });

    const data = {
      element: tracking?.element ?? 'favourite_room',
      section: tracking?.section ?? 'room_card',
      room_id: roomId,
      element_value: roomId,
      country: window.__TGV_ISO_COUNTRY_CODE,
      interaction: action === 'remove' ? 'unselect' : 'select',
    };

    App.track.event('favourites_list_updated', data);
  };

  const getSavedRoomsIds = () => {
    return [...wishListRooms];
  };

  const getSavedRoomsCount = () => {
    return getSavedRoomsIds().length;
  };

  const removeAjax = (roomId) => {
    $.post('/ajax/wish-list/remove', { roomId });
  };

  const addAjax = (roomId) => {
    return new Promise((resolve, reject) => {
      $.post('/ajax/wish-list/add', {
        roomId,
      })
        .done(() => {
          resolve();
        })
        .fail(() => {
          reject()
        })
    });
  };

  const getSavedRoomIndex = (roomId) => {
    if (wishListRooms) {
      return wishListRooms.indexOf(roomId);
    }

    return null;
  };

  const updateDOMWithState = () => {
    $(HEARTS_SELECTOR).each((index, el) => {
      const id = +el.dataset.id;

      if (wishListRooms.indexOf(id) > -1) {
        el.classList.add('c-room-card__heart--selected');
      } else {
        el.classList.remove('c-room-card__heart--selected');
      }
    });

    $.publish('wishList:change', wishListRooms.length);
  };

  const isGuest = () => {
    return userData.type === 'guest';
  };

  const redirectToLoginPage = (roomId) => {
    window.sessionStorage.setItem(WISHLIST_LOCAL_STORAGE_KEY, roomId);
    window.location = `/signup/client?redirectUrl=${window.location.href}`;
  };

  /**
   * @param index
   * @param roomId
   * @returns {boolean}  True if was successfully added
   */
  const removeFromSaved = (index, roomId, tracking) => {
    const rooms = wishListRooms;

    const updatedRooms = [
      ...rooms.slice(0, index),
      ...rooms.slice(index + 1),
    ];

    wishListRooms = updatedRooms;

    removeAjax(roomId);

    track(TRACKING_ACTIONS.remove, roomId, tracking);
    updateDOMWithState();

    if (typeof window.showMessageAboutSuccessfulRemovingToWishlist === 'function') {
      window.showMessageAboutSuccessfulRemovingToWishlist();
    }

    return true;
  };

  /**
   * @param roomId
   * @returns {Promise{boolean}} True if was successfully added
   */
  const addToSaved = (roomId, { autoSaved } = {}, tracking = {}) => {
    return new Promise((resolve, reject) => {
      if (isGuest()) {
        track(TRACKING_ACTIONS.addGuest, roomId, tracking);

        if (typeof window.triggerWishlistModal === 'function') {
          window.triggerWishlistModal(roomId);
          return resolve(false);
        }

        setTimeout(() => redirectToLoginPage(roomId), 100);
        return resolve(false);
      }

      addAjax(roomId)
        .then(() => {
          if (wishListRooms.includes(roomId)) {
            window.sessionStorage.removeItem(WISHLIST_LOCAL_STORAGE_KEY);
            return resolve(false);
          }

          wishListRooms = [...wishListRooms, roomId];
          track(autoSaved ? TRACKING_ACTIONS.autoAdd : TRACKING_ACTIONS.add, roomId, tracking);

          if (typeof window.showMessageAboutSuccessfulAddingToWishlist === 'function') {
            window.showMessageAboutSuccessfulAddingToWishlist();
          }

          updateDOMWithState();
          return resolve(true);
        })
        .catch((error) => {
          reject(false);
          throw error;
        });
    });
  };

  const toggleSaved = (roomId, tracking) => {
    const roomIndex = getSavedRoomIndex(roomId);
    if (roomIndex > -1) {
      window.sessionStorage.removeItem(WISHLIST_LOCAL_STORAGE_KEY);
      return Promise.resolve(removeFromSaved(roomIndex, roomId, tracking));
    } else {
      return addToSaved(roomId, {}, tracking);
    }
  };

  const isFavourite = (roomId) => {
    const index = getSavedRoomIndex(roomId);

    if (index > -1) {
      return true;
    }

    return false;
  };

  const updateRoomsFromUrl = () => {
    if (isGuest()) {
      return;
    }

    const roomId = window.sessionStorage.getItem(WISHLIST_LOCAL_STORAGE_KEY);
    if (roomId) {
      addToSaved(+roomId, { autoSaved: true }).then(() => {
        $.publish('wishList:added_from_url', +roomId);
        updateDOMWithState();
      });
    }
  };

  // auto attach events to room card hearts
  const init = (items = [], user) => {
    wishListRooms = items;
    userData = user;

    updateDOMWithState();

    setTimeout(() => {
      updateRoomsFromUrl();
    }, 750);

    $(document).on('click', HEARTS_SELECTOR, (event) => {
      const id = +event.target.dataset.id;

      const tracking = {};
      if (event.target.dataset.trackSection) {
        tracking.section = event.target.dataset.trackSection;
      }
      if (event.target.dataset.trackElement) {
        tracking.element = event.target.dataset.trackElement;
      }

      const saved = toggleSaved(id, tracking);

      if (saved) {
        updateDOMWithState();
      }
    });
  };

  const deferred = jQuery.Deferred();

  $(document).ready(() => {
    App.es6.shared.user_data.getUser().then(user => {
      init(user.wishList, user);

      deferred.resolve({
        TRACKING_ACTIONS,
        getSavedRoomsIds,
        getSavedRoomsCount,
        toggleSaved,
        updateDOMWithState,
        isFavourite,
      });
    });
  });

  return deferred;
});
